import styled from 'styled-components';
import { Switch } from 'antd';


export const StyledSwitch = styled(Switch)`
  width: 66px;
  min-width: 66px;
  height: 30px !important;

  .ant-switch-handle:before {
    height: 24px !important;
    width: 24px !important;
    top: 1px !important;
    border-radius: 12px;
  }
  
  &.ant-switch-checked {
  	background-color: ${({theme}) => theme.colors.backgroundPutty};

    .ant-switch-handle:before {
      margin-left: -7px;
    }
  }
`;
